import {
  MultiSelectField as MultiSelectElement,
  TextField as TextFieldElement,
  useAppFormContext
} from '@treneo/shared/forms';
import { useAppTranslations } from '@treneo/shared/i18n';

import { courseFormFieldNames } from '../course-form-field-names';
import { ParticipantFieldContainer, ParticipantsRow } from '../styled';

type Props = {
  hasAttemptedSubmit: boolean;
  formValidationErrors: Record<string, string>;
  datacenterOptions: Array<{ id: string; label: string; description: string }>;
};

export const ParticipantsSection = ({
  hasAttemptedSubmit,
  formValidationErrors,
  datacenterOptions
}: Readonly<Props>) => {
  const { t } = useAppTranslations();
  const { formState } = useAppFormContext();

  const getFieldError = (fieldName: string): string | undefined => {
    const rhfError = formState.errors[fieldName as keyof typeof formState.errors];
    const customError = formValidationErrors[fieldName];

    if (hasAttemptedSubmit) {
      if (customError) {
        return customError;
      }
      if (rhfError?.message) {
        return typeof rhfError.message === 'string' ? rhfError.message : undefined;
      }
    }
    return undefined;
  };

  const expectedParticipantsError = getFieldError(courseFormFieldNames.expectedParticipants);
  const maxParticipantsError = getFieldError(courseFormFieldNames.maxParticipants);

  return (
    <ParticipantsRow>
      <ParticipantFieldContainer>
        <TextFieldElement
          name={courseFormFieldNames.expectedParticipants}
          label={t('courseForm.expectedParticipants')}
          type='number'
          fullWidth
          error={!!expectedParticipantsError}
          helperText={expectedParticipantsError ? t(expectedParticipantsError) : ''}
        />
      </ParticipantFieldContainer>

      <ParticipantFieldContainer>
        <TextFieldElement
          name={courseFormFieldNames.maxParticipants}
          label={t('courseForm.maxParticipants')}
          type='number'
          required
          fullWidth
          error={!!maxParticipantsError}
          helperText={maxParticipantsError ? t(maxParticipantsError) : ''}
        />
      </ParticipantFieldContainer>

      <ParticipantFieldContainer>
        <MultiSelectElement
          name={courseFormFieldNames.daDataCenterIds}
          label={t('courseForm.dataCenter')}
          options={datacenterOptions}
          fullWidth
        />
      </ParticipantFieldContainer>
    </ParticipantsRow>
  );
};
